<template>
  <div class="login-container">
    <el-card class="login-card">
      <template slot="header">
        <div class="login-header">
          <h2>管理后台登录</h2>
        </div>
      </template>
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" label-width="80px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="loginForm.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleLogin" :loading="loading" style="width: 100%">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      loginForm: {
        username: 'admin',
        password: '123456'
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleLogin() {
      // 先验证表单
      this.$refs.loginForm.validate(valid => {
        if (!valid) return
        
        this.loading = true
        api.post('/admin/login/login', this.loginForm)
        .then(() => {
          this.$message.success('登录成功')
          this.$router.push('/')
          window.location.reload() // 刷新页面以更新登录状态
        })
        .catch(error => {
          console.error('登录失败:', error)
          this.$message.error(error.message || '登录失败，请检查网络')
        })
        .finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fa;
}

.login-card {
  width: 400px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.login-header {
  text-align: center;
}

.login-header h2 {
  margin: 0;
  color: #303133;
}

.el-form {
  margin-top: 20px;
}
</style>